import { makeAutoObservable, runInAction } from "mobx";
import {fetchAllCourseOptions} from "../services";

const courseOptionsStore = makeAutoObservable({
    data: null,
    isLoading: false,
    error: null,

    async fetchAllCoursesOptionsData() {
        if (this.data !== null) return;

        this.isLoading = true;
        try {
            const result = await fetchAllCourseOptions();
            runInAction(() => {
                this.data = result; // MobX обновляет наблюдаемые свойства
                this.error = null;
            });
        } catch (error) {
            runInAction(() => {
                this.error = error;
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }
});

export default courseOptionsStore;
